module.exports = __webpack_public_path__ + "static/img/Flat.a0d1f7b3.svg";